import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { TAllPurchasedServicesResponse } from './types';

export function useMarketplaceServicesForCompany({
  companyId,
}: {
  companyId: number;
}): {
  data?: TAllPurchasedServicesResponse[];
  error?: unknown;
  mutate: KeyedMutator<any>;
} {
  const queryParams = new URLSearchParams();
  queryParams.append('companyId', companyId?.toString() || '');

  const { data, error, mutate } = useSWR<TAllPurchasedServicesResponse[]>(
    `billing-new/purchased-services?${queryParams.toString()}`,
    SWRFetcher({
      method: 'GET',
    })
  );

  return { data, error, mutate };
}
